import { isMobile } from 'react-device-detect';
import {
  isUserStatusFree,
  isUserStatusInactive,
  isUserStatusNew,
  isUserStatusSubscribed
} from '../utils/CheckUserStatus';
import {
  isSubscriptionTypeBasic,
  isSubscriptionTypeElite,
  isSubscriptionTypePro
} from '../utils/CheckSubscriptionType';

export const defaultRoute = (userStatus, subscriptionType) => {
  if (isUserStatusInactive(userStatus)) {
    return '/myprofile';
  }

  if (subscriptionType === undefined) {
    if (isUserStatusNew(userStatus)) {
      return '/freetrial';
    } else if (isUserStatusFree(userStatus)) {
      if (isMobile === true) {
        return '/myprofile';
      } else {
        return '/dashboard';
      }
    } else if (isUserStatusSubscribed(userStatus)) {
      return '/dashboard';
    } else if (isUserStatusInactive(userStatus)) {
      return '/myprofile';
    }
  } else {
    if (
      isSubscriptionTypePro(subscriptionType) ||
      isSubscriptionTypeElite(subscriptionType)
    ) {
      return '/dashboard';
    } else if (isSubscriptionTypeBasic(subscriptionType)) {
      return '/openstax';
    }
  }

  return '/myprofile';
};
